import SplitPageHero from '../common/SplitPageHero'
import { leadershipHero } from '../../data/leadershipPageData'

const leadershipHeroImage = '/assets/leadership-hero-bg.png'

function LeadershipPageHero() {
  const { eyebrow, titleLine1, titleAccent, titleLine2, description, primaryCta, secondaryCta } =
    leadershipHero

  return (
    <SplitPageHero
      id="leadership-page-heading"
      eyebrow={eyebrow}
      title={
        <>
          {titleLine1} <span className="split-page-hero__title-accent">{titleAccent}</span>
          <br />
          {titleLine2}
        </>
      }
      description={description}
      image={leadershipHeroImage}
      imageAlt="Business leadership team in professional corporate setting"
      primaryCta={primaryCta}
      secondaryCta={secondaryCta}
    />
  )
}

export default LeadershipPageHero
